import { Link } from "react-router-dom";

const footerLinks = [
  {
    title: "快速导航",
    links: [
      { label: "首页", path: "/" },
      { label: "赛事资讯", path: "/category/saishi-zixun" },
      { label: "数据分析", path: "/category/shuju-fenxi" },
      { label: "下载指南", path: "/category/xiazai-zhinan" },
    ],
  },
  {
    title: "帮助支持",
    links: [
      { label: "使用教程", path: "/category/shiyong-jiaocheng" },
      { label: "常见问题", path: "/category/xiazai-zhinan" },
      { label: "版本更新", path: "/category/saishi-zixun" },
      { label: "联系我们", path: "/about" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "品牌介绍", path: "/about" },
      { label: "用户故事", path: "/category/yonghu-gushi" },
      { label: "行业动态", path: "/category/hangye-dongtai" },
      { label: "隐私政策", path: "/about" },
    ],
  },
];

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-trophy-line text-lg text-white"></i>
                </div>
                <span className="text-lg font-bold text-white">大满贯</span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed mb-5">
                专业的体育赛事直播与数据分析平台，为体育爱好者提供极致的观赛体验。
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-background-300"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-background-300"></i>
                </a>
                <a href="#" className="w-9 h-9 rounded-lg bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                  <i className="ri-tiktok-line text-background-300"></i>
                </a>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-white mb-4">{group.title}</h4>
                <ul className="flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="border-t border-foreground-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {currentYear} 大满贯APP 版权所有 | 粤ICP备XXXXXXXX号-1
            </p>
            <div className="flex items-center gap-6">
              <a href="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">用户协议</a>
              <a href="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">隐私政策</a>
              <a href="/about" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}